module.exports = __webpack_public_path__ + "app/assets/img/gafam/1000minds.png";